export const defaultServerLabel = 'Instance Name';

export const defaultServerHostname = 'server24.kr';


export const defaultZendeskIpFieldId = 4413163323407;
